import { Popover as BasePopover } from "@base-ui/react/popover";
import { useFloatingPortalContainer } from "@frontend/contexts";

import type { TimePickerPortalProps } from "./TimePicker.types";

export function TimePickerPortal({
  children,
  ...props
}: TimePickerPortalProps) {
  const container = useFloatingPortalContainer();

  return (
    <BasePopover.Portal
      data-slot="time-picker-portal"
      container={container}
      {...props}
    >
      {children}
    </BasePopover.Portal>
  );
}
